import { Header, Main } from '@pcrm/fe/ui-kit';
import { createFileRoute, Outlet } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/setari')({
  component: SetariLayout,
});

/**
 * Cadrul zonei de administrare, portat din edinro (`features/settings/settings-layout.tsx`).
 *
 * **Aici `Header` și `Main` stau în layout, nu în pagină** — abatere conștientă de la
 * convenția din `authenticated-layout.tsx`. Zona are cinci ecrane cu același antet; scris
 * în fiecare, s-ar fi desincronizat la prima corectură. Convenția spune că fiecare ecran
 * își alege antetul: zona asta și-a ales unul, o dată.
 *
 * **Fără titlu și descriere de zonă în corpul paginii** (fondatorul, 2026-08-13): fiecare
 * ecran și-l poartă pe al lui, pe cardul lui. Un antet de zonă peste antetul secțiunii
 * spunea de două ori aproape același lucru și împingea conținutul în jos degeaba.
 */
function SetariLayout() {
  return (
    <>
      <Header fixed>
        <h1 className="text-lg font-semibold">Setări</h1>
      </Header>

      <Main className="flex flex-1 flex-col gap-4 sm:gap-6">
        <Outlet />
      </Main>
    </>
  );
}
